import React, { Component } from 'react';
import './Loader.css';
class Loader extends Component {
    render() {
        return (
            <div style={{ float: "none", margin: "0 auto"}} className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        );
    }
}

export default Loader;